<!-- 报名人数统计 -->
<template>
  <div
    class='ement_wrap'
    :style="{
      backgroundColor: `${options.style.bgColor}`,
      fontSize: `${options.style.preSize}px`,
      color: `${options.style.txtColor}`,
    }"
  >
    <div class="ement_body">
      {{options.data.preText}} <span
        class="ement_num"
        :style="{
        color: `${options.style.numColor}`,
        fontSize: `${options.style.numSize}px`,
      }"
      >{{Math.floor(enrollment)}}</span> 人
    </div>
  </div>
</template>

<script>
import { TweenLite } from 'gsap'
export default {
  props: {
    options: {
      type: Object,
      default: () => { }
    },
    number: {
      type: Number,
      default: 0
    }
  },
  name: 'Enrollment',
  data() {
    return {
      enrollment: 0
    };
  },

  watch: {
    number(val) {
      TweenLite.to(this.$data, {
        duration: 0.3,
        enrollment: val,
      })
    }
  },

  components: {},

  methods: {

  },

  mounted() {

  },
}
</script>
<style lang='less' scoped>
.ement_wrap {
  padding: 5px 20px;
  line-height: 1.2;
  text-align: center;
  .ement_body {
    flex: 1;
    .ement_num {
      font-weight: bold;
    }
  }
}
</style>